import type { Meta } from '../ThemeTypes';

const meta: Meta = {
  title: 'Loop Optimise',
  description:
    "Loop Optimise will buy and store energy when it's cheap, and sell it back to the grid when it’s expensive.",
  manifestPath: '/loopManifest.json',
};

export default meta;
